/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementViewOrderResponse } from './MemberManagementViewOrderResponse';

export type MemberManagementViewOrderResponseApiRespoonse = {
    data?: MemberManagementViewOrderResponse;
    status?: MemberManagementViewOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementViewOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

